import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import {
  CheckoutWrapperComponent,
  OrderSubmitService,
  CheckoutConfigService,
  CartService,
  GungModalService,
  CartKeyService,
  CartListCheckoutConfigService
} from 'gung-standard';
import { CultUnifaunReturnsService, ShipmentPrints } from '../../../services/cult-unifaun-returns.service';

@Component({
  selector: 'cult-cult-checkout-wrapper',
  templateUrl: './cult-checkout-wrapper.component.html',
  styleUrls: ['./cult-checkout-wrapper.component.scss']
})
export class CultCheckoutWrapperComponent extends CheckoutWrapperComponent {
  constructor(
    protected orderSubmitService: OrderSubmitService,
    protected checkoutConfig: CheckoutConfigService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected cartService: CartService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected gungModalService: GungModalService,
    protected cultUnifaunReturnsService: CultUnifaunReturnsService,
    protected cartKeyService: CartKeyService,
    protected cartListCheckoutConfigService: CartListCheckoutConfigService
    
  ) {
    super(
      orderSubmitService,
      checkoutConfig,
      componentFactoryResolver,
      cartService,
      changeDetectorRef,
      gungModalService,
      cartKeyService,
      cartListCheckoutConfigService
    );
  }

  openShipmentPdfNewWindow(shipmentPrint: ShipmentPrints) {
    this.cultUnifaunReturnsService.openShipmentPdfNewWindow(shipmentPrint);
  }
}
